import React, { useState, useEffect } from 'react'
import styles from "./styles.module.css";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'

import { getUniversity } from '../../../actions/report';

import BtnBack from '../helper/btnBackMTO/BtnBack';
import GetHeader from '../helper/getHeader/GetHeader';

import bg from '../../../assets/dashboard/background_1.png'
import logo_big from '../../../assets/dashboard/logo_big.png'
import { BACKEND_URL_PREFIX } from '../../../utils/const';

const Faculties = ({
  university,
  getUniversity,
  match,
  location,
  history
}) => {

  const [uni, setUni] = useState(null);
  const [facultyList, setFacultyList] = useState(null);

  const { id } = match.params

  useEffect(() => {
    getUniversity();
  }, []);

  useEffect(() => {
    if (university && university.length > 0 && id != null && id != 'all') {
      const [one, two] = id.split('_');
      const univer = two ? university[one].branches[two] : university[one]
      const prefix = univer?.api_url
      if (prefix?.length > 1) {
        const url = `${prefix}faculty`
        fetch(url)
          .then(resp => resp.json())
          .then(data => setFacultyList(data))
      }
      setUni(univer)
    }
    if (id == 'all') {
      const url = `${BACKEND_URL_PREFIX}/faculty?limit=1000&offset=0&web=1`
      fetch(url)
        .then(resp => resp.json())
        .then(data => setFacultyList(data.items))
    }

  }, [university]);



  const renderFacult = ({ faculty: name, idfaculty }) => {
    const link = `${location.pathname}/${idfaculty}`
    return (
      <div className={styles.wrapperList} key={name}>
        <Link to={link} className={styles.itemLink}>
          <div className={styles.item}>
            <span>{name}</span>
          </div>
        </Link>
      </div>
    )
  }


  return (
    <div className={styles.wrapper}>
      <img src={bg} className={styles.bg} />
      <div className={styles.logo_bigWrapper}>
        <img src={logo_big} className={styles.logo_big} />
      </div>
      <GetHeader title={<>ФАКУЛЬТЕТЫ ОБРАЗОВАТЕЛЬНОЙ ОРГАНИЗАЦИИ <br /> {uni?.name}</>} pathLogo={uni?.api_url} />

      <div className={styles.wrapperBlock}>
        {facultyList?.map(renderFacult)}
      </div>

      <BtnBack />
    </div>
  )
}


const mapStateToProps = (state) => ({
  university: state.report.university
});

export default connect(mapStateToProps, {
  getUniversity
})(Faculties);